<template>
  <div class="compare-table">
    <div class="mii-table mii-table-2" style="height:8rem;" v-if="caseDatas.length > 0">
      <content-title title="成本对比"></content-title>
      <table :class="{'table-style-2': 1, 'scroll-table': scroll_table}">
        <thead>
          <tr class="th-1">
            <th :colspan="caseDatas.length" v-for="(thData, indexn) in ths2">{{thData.label}}</th>
          </tr>
          <tr>
            <template v-for="(thData, index2) in ths2">
              <th v-for="(caseData, index) in caseDatas" :class="{'border-th': index === 0 && index2 !== 0}">{{caseData.name}}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in caseDatas[0]['result']['成本']">
            <template v-for="(thData, index) in ths2">
              <td v-for="(caseDataOne, indeCase) in caseDatas" :class="{'border-th': indeCase === 0 && index !== 0}">{{caseDatas[indeCase]['result']['成本'][0][thData.key]}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mii-table mii-table-2" v-if="caseDatas.length > 0">
      <div class="table-tool">
        <a href="javascript:;">
          <i class="iconfont icon-zhankai-copy" @click="scroll_table_2 = !scroll_table_2"></i>
        </a>
        <a href="javascript:;">
          <i class="iconfont icon-daochu" @click="optPutFile"></i>
        </a>
      </div>
      <content-title title="结果对比"></content-title>
      <table :class="{'table-style-2': 1, 'scroll-table': scroll_table_2}">
        <thead>
          <tr class="th-1">
            <th :colspan="thData.label === '时间' ? 1 : caseDatas.length" v-for="thData in ths" >{{thData.label}}</th>
          </tr>
          <tr>
            <template v-for="thData in ths">
              <th v-if="thData.label === '时间'"></th>
              <th v-for="(caseData, index1) in caseDatas" v-else :class="{'border-th': index1 === 0}">{{caseData.name}}</th>
            </template>
          </tr>
        </thead>
        <tbody :style="table_style_height">
          <tr v-for="(data, index) in caseDatas[0]['result']['调度方案']" style="overflow: auto;max-height: 20rem;">
            <template v-for="thData in ths">
              <td v-if="thData.label === '时间'">{{caseDatas[0]['result']['调度方案'][index][thData.key]}}</td>
              <td v-for="(caseDataOne, indeCase) in caseDatas" v-else :class="{'border-th': indeCase === 0}">{{caseDatas[indeCase]['result']['调度方案'][index][thData.key]}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import ContentTitle from '../components_bit/ContentTitle'
  import {
    outPutExcelFile
  } from '../cllib'
  export default {
    components: {
      'content-title': ContentTitle
    },
    methods: {
      optPutFile () {
        let datas = [{
          data: [],
          sheetName: 'data1'
        }]
        let vm = this
        let row1 = ['时间']
        let row2 = ['']
        this.ths.slice(1).forEach(function (thsItem) {
          vm.caseDatas.forEach(function (item) {
            row1.push(thsItem.label)
            row2.push(item.name)
          })
        })
        datas[0].data.push(row1)
        datas[0].data.push(row2)
        this.caseDatas[0]['result']['调度方案'].forEach(function (item, index1) {
          let data = []
          vm.ths.forEach(function (item2, index2) {
            if (index2 !== 0) {
              vm.caseDatas.forEach(function (item3) {
                data.push(item3['result']['调度方案'][index1][item2.key])
              })
            } else {
              data.push(vm.caseDatas[0]['result']['调度方案'][index1][item2.key])
            }
          })
          datas[0].data.push(data)
        })
        outPutExcelFile(datas, '结果对比.xls')
      }
    },
    computed: {
      table_style_height: {
        get () {
          if (this.table_height && this.scroll_table) {
            return {
              height: this.table_height + 'rem'
            }
          } else {
            return {}
          }
        }
      }
    },
    data () {
      return {
        scroll_table: true,
        scroll_table_2: true,
        ths: [{
          label: '时间',
          key: 0
        },
        {
          label: '光伏发电',
          key: 2
        },
        {
          label: '购电量',
          key: 4
        },
        {
          label: '卖电量',
          key: 5
        },
        {
          label: '电池充电',
          key: 7
        },
        {
          label: '电池放电',
          key: 8
        },
        {
          label: 'SOC',
          key: 9
        }],
        ths2: [{
          label: '购电成本',
          key: 0
        },
        {
          label: '储能成本',
          key: 1
        },
        {
          label: '光伏发电成本',
          key: 2
        }]
      }
    },
    props: ['caseDatas', 'table_height']
  }
</script>

<style lang="less">
  .mii-table{
    .icon-jiantou {
      font-weight: 600;
      padding: 0 0.2em;
    }
    .el-pagination button {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pager li {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pager li.active {
      background-color: #20a0ff;
    }
  }
</style>

<style scoped lang="less">
  @import '../style/base.less';
  .table-tool {
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    i {
      font-size: 1.3rem;
      margin-left: 1rem;
      color: #fff;
    }
  }
  .th-1 {
    th {
      background-color: rgba(12, 85, 145, 0.2) !important;
    }
  }
  .compare-table {
    display: block;
  }
  .scroll-table {
    tbody {
      display:block;
      height: 25rem;
      overflow-y:scroll;
    }
    thead, tbody tr {
      display:table;
      width:100%;
      table-layout:fixed;
    }
  }
  .border-th {
    border-left: 0.05rem solid rgba(0, 0, 0, 0.2);
  }
  .mii-table-1 {
    margin-bottom: 3rem;
    background-color: @bak-color-td-2;
  }
  .mii-table-2 {
    margin-bottom: 2rem;
    background-color: @bak-color-td-1;
  }
  .pagination-table {
    text-align: right;
    margin-right: 0.5em;
  }
  .mii-table {
    position: relative;
    display: flex;
    flex:1;
    flex-direction:column;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    padding-bottom: @content-border-radius-size;
    border-radius: @content-border-radius-size;
    input {
      width: 6em;
      line-height: 1;
      padding: 0;
      margin: 0;
      font-size: 1em;
    }
    table {
      border-spacing: 0;
      width: 100%;
      th {
        background-color: @bak-color-th;
        font-size: 1.13em;
        line-height: 2;
        color: @font-color-3;
        font-weight: 100;
        text-align: center;
      }
      td {
        text-align: center;
        font-size: 1em;
        line-height: 1.6;
        color: @font-color-3;
      }
      th:first-child {
        padding-left: 2.5em;
      }
      td:first-child {
        padding-left: 2.5em;
      }
    }
    .one-row {
      td {
        line-height: 2.4;
      }
      tr:nth-child(odd){
        background: #fff;
      }
      tr:nth-child(even){
        background: @bak-color-td-1;
      }
    }
    .table-style-2 {
      tr:nth-child(odd){
        background: @bak-color-td-2;
      }
      tr:nth-child(even){
        background: @bak-color-td-1;
      }
    }
    .table-style-1 {
      tr:nth-child(odd){
        background: @bak-color-td-1;
      }
      tr:nth-child(even){
        background: @bak-color-td-2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CaseCompareTable.vue?12eb9868